function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function SvgComponent({
  height,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M11.6783 2.73262L11.9884 3.11236L12.2982 2.73237C12.7389 2.19175 13.2746 1.72342 13.8854 1.34958C14.8994 0.728975 16.075 0.400024 17.2857 0.400024C17.7008 0.400024 18.1158 0.43884 18.5189 0.515231C19.5876 0.717719 20.5961 1.19442 21.4344 1.89364C22.2719 2.59221 22.9022 3.48149 23.2601 4.46277C23.522 5.18076 23.6345 5.95452 23.5915 6.76496C23.5141 8.22217 22.9509 9.81093 21.8288 11.6323C19.8843 14.7885 16.7554 17.656 12.2264 20.3901L11.9899 20.5328L11.7535 20.3901C8.07295 18.1682 5.32474 15.8544 3.33379 13.3205C2.41331 12.1489 1.22237 10.3597 0.688024 8.41932C0.419582 7.44453 0.340635 6.51951 0.444491 5.66757C0.562882 4.69662 0.920343 3.7972 1.51046 2.99063C2.08628 2.20356 2.86823 1.54714 3.77227 1.0954C4.67699 0.643324 5.68813 0.40431 6.69419 0.40431C7.90398 0.40431 9.07876 0.732785 10.0923 1.35248C10.7024 1.72559 11.2377 2.19304 11.6783 2.73262Z",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: "0.8"
  }));
}

SvgComponent.defaultProps = {
  width: 24,
  height: 21
};
SvgComponent.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;